<template>
    <div class="setdate">
        <z-title title="重点日期设置" ref="title"></z-title>
        <el-card class="content1" ref="search">
            <div class="flex-n fac fjb">
            <el-date-picker
                    size="medium"
                    v-model="datevalue"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions">
            </el-date-picker>
            <div class="flex-n fac">
                <el-button type="primary" class="ele-btn2" @click="searchList">查询</el-button>
                <el-button type="primary" class="ele-btn1" @click="addDate">新增日期</el-button>
            </div>
            </div>
        </el-card>
        <el-card class="mt-10">
            <el-table
                    v-loading="loading"
                    :height="height+'px'"
                    highlight-current-row
                    element-loading-text="列表刷新中"
                    element-loading-spinner="el-icon-loading"
                    header-cell-class-name="headerrow"
                    cell-class-name="cellclass"
                    :data="dataList"
                    style="width: 100%">
                <el-table-column
                        fixed
                        label="日 期"
                        width="250"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.startDate +'~' +scope.row.endDate }}
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="alertRemark"
                        label="说 明"
                      >
                </el-table-column>
                <el-table-column
                        prop="remark"
                        label="备 注"
                        align="center">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="130"
                        align="center">
                    <template slot-scope="scope">
                        <div style="margin: 5px 0">
                            <el-button type="primary" class="ele-btn-small" @click="editDate(scope.row.id)">编辑</el-button>
                            <el-popconfirm
                                    :title="'确定删除该重点日期么吗？'"
                                    @onConfirm="delDate(scope.row.id)"
                                    class="ml-10"
                            >
                                <el-button slot="reference" type="primary" class="ele-btn-small">删除</el-button>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                        @currentChange="handleCurrentChange"></pagination>
        </el-card>
        <!--新增日期-->
        <el-dialog :visible.sync="showedit"
                   :close-on-click-modal="false"
                    class="ele-toast">
            <div slot="title">
                <z-title :title="editstate+'重点日期'"></z-title>
            </div>
            <el-form :model="dataForm" :rules="rules" ref="dataForm" class="rulefrom">
                <div class="time">* 如选择一天作为重点日期，请将开始日期和结束日期设置为同一天</div>
                <el-form-item label="日期范围" prop="date" label-width="80px">
                    <el-date-picker
                            style="width: 100%"
                            v-model="dataForm.date"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="日期级别" prop="dateLevel" label-width="80px">
                    <el-select v-model="dataForm.dateLevel"  value-key="dicCode" @visible-change="getDateLevel" placeholder="请选择日期级别" style="width: 100%">
                        <el-option
                                v-for="item in dateLevel"
                                :key="item.dicCode"
                                :label="item.dicName"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="说 明" prop="alertRemark" label-width="80px">
                    <el-input type="textarea" rows="6" show-word-limit v-model="dataForm.alertRemark" resize="none"
                              maxlength="512"></el-input>
                </el-form-item>
                <el-form-item label="备 注" prop="remark" label-width="80px">
                    <el-input type="textarea" rows="6" show-word-limit v-model="dataForm.remark" resize="none"
                              maxlength="512"></el-input>
                </el-form-item>
                <el-form-item class="mt-10 flex-n fje">
                    <el-button type="primary" @click="submitForm('dataForm')">保 存</el-button>
                    <el-button @click="showedit = false">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import Pagination from "../../components/pagination/pagination";


    export default {
        components: {
            Pagination,
            ZTitle
        },
        name: "date",
        data() {
            return {
                loading: false,
                pageSize: 20,
                currentPage: 1,
                total: 0,
                height:250,
                dataForm:{},
                editstate: '新增',
                showedit: false,

                dateLevel:[],
                dataList: [],

                datevalue: [],
                id:'',

                rules: {
                    date: [{type: 'array', required: true, message: '日期范围不能为空', trigger: 'change'}],
                    dateLevel:[{required: true, message: '日期级别不能为空', trigger: 'change'}],
                    alertRemark:[{required: true, message: '说明不能为空', trigger: 'blur'}]
                },

            }
        },
        mounted() {
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 200;
                console.log(this.height)
            },0)
            this.getDataList();
            this.getDateLevel(true);
        },
        computed:{
            pickerOptions() {
                var that=this;
                return{
                    firstDayOfWeek: 1,
                    shortcuts: [
                        {
                            text: '今日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '昨日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24);
                                end.setTime(end.getTime() - 3600 * 1000 * 24);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                var num=start.getDay();
                                if(num==0){
                                    num=7;
                                }
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (num-1));
                                end.setTime(end.getTime() + 3600 * 1000 * 24 * (7-num));
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '上周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                var num=start.getDay();
                                if(num==0){
                                    num=7;
                                }
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (num+6));
                                end.setTime(end.getTime() - 3600 * 1000 * 24 * num);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本月',
                            onClick(picker) {
                                const start = new Date();
                                var year=start.getFullYear(),month=start.getMonth()+1;
                                var startDate=new Date(year+'-'+month+'-1');
                                var length=that.$TM.getMonthArea().length-1;
                                var dd=that.$TM.getMonthArea()[length].dd;
                                var endDate= new Date(that.$TM.getMonthArea()[length-(dd<7?dd:0)].date);
                                console.log(startDate,endDate)
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '上月',
                            onClick(picker) {
                                const start = new Date();
                                console.log(that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1}))
                                var month=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[15].mm,
                                    year=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[15].yy;
                                var length=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1}).length-1;
                                var dd=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[length].dd;
                                var startDate=new Date(year+'-'+month+'-1');
                                var endDate= new Date(that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[length-(dd<7?dd:0)].date);
                                // console.log(startDate,endDate)
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        }
                    ]
                }
            },

        },
        watch:{
            showedit(newval,oldval){
                if(!newval){
                    this.$refs.dataForm.resetFields();
                }
            }
        },
        methods: {
            //重点日期级别
            getDateLevel(isshow){
                if(isshow){
                    this.$axios.post('/dic/importantDateLevelCode',{
                        "parentId": "1001",
                        "dicType": " important_level_code"
                    }).then(res=>{
                        console.log('重点日期级别',res.data.list)
                        this.dateLevel=res.data.list;
                    }).catch(err=>{
                        this.$message.error(err.msg);
                    })
                }
            },
            //查询重点日期
            getDataList(){
                this.loading=true;
                console.log('日期区间',this.datevalue)
                this.$axios.post('/importantDate/importantDateList',{
                    "storeId": this.$root.getStorage('storeId'),
                    "startDate": this.datevalue?this.datevalue[0]:'',
                    "endDate": this.datevalue?this.datevalue[1]:'',
                    "pageNum":this.currentPage,
                    "pageSize":this.pageSize
                }).then(res=>{
                    console.log('查询重点日期',res.data)
                    this.dataList = res.data.list;
                    this.total=res.data.total;
                    this.loading=false;
                }).catch(err=>{
                    this.$message.error(err.msg);
                    this.loading=false;
                })
            },
            //搜索
            searchList(){
                this.currentPage=1;
                this.getDataList();
            },
            //新增
            addDate() {
                this.showedit = true;
                this.editstate = '新增'
            },
            //编辑
            editDate(id) {
                console.log('编辑',id)
                this.id=id;
                this.showedit = true;
                this.editstate = '编辑';
                this.$axios.get('/importantDate/importantDateById/'+id).then(res=>{
                    console.log(res)
                    var dataForm=res.data;
                    dataForm.date=[res.data.startDate,res.data.endDate];
                    dataForm.dateLevel={
                        dicCode:dataForm.dateLevelCode,
                        dicName:dataForm.dateLevelName
                    }
                    this.dataForm=dataForm;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //删除
            delDate(id){
                console.log(id)
                    this.$axios.post('/importantDate/importantDeleteById/',id).then(res=>{
                        this.$message.success('删除重点日期成功！');
                        this.getDataList();
                    }).catch(err=>{
                        this.$message.error(err.msg);
                    })
            },
            //添加提交
            addSubmit(){
                let {date,dateLevel,alertRemark,remark}=this.dataForm;
                    this.$axios.post('/importantDate/importantDateAdd',{
                        "storeId": this.$root.getStorage('storeId'),
                        "startDate": date[0],
                        "endDate": date[1],
                        "dateLevelCode":dateLevel.dicCode,
                        "dateLevelName": dateLevel.dicName,
                        "alertRemark": alertRemark,
                        "remark": remark
                    }).then(res=>{
                        this.currentPage=1;
                        this.getDataList();
                        this.$message.success('新增重点日期成功！')
                        this.showedit = false;
                    }).catch(err=>{
                        this.$message.error(err.msg);
                    })
            },
            //编辑提交
            editSubmit(){
                let {date,dateLevel,alertRemark,remark}=this.dataForm;
                    this.$axios.post('/importantDate/importantDateUpdate',{
                        "id": this.id,
                        "storeId": this.$root.getStorage('storeId'),
                        "startDate": date[0],
                        "endDate": date[1],
                        "dateLevelCode":dateLevel.dicCode,
                        "dateLevelName": dateLevel.dicName,
                        "alertRemark": alertRemark,
                        "remark": remark
                    }).then(res=>{
                        this.getDataList();
                        this.$message.success('编辑重点日期成功！')
                        this.showedit = false;
                    }).catch(err=>{
                        this.$message.error(err.msg);
                    })
            },
            //验证表单
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.editstate == '新增'){
                            this.addSubmit();
                        }else{
                            this.editSubmit();
                        }
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSize=val;
                this.getDataList();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage=val;
                this.getDataList();
                console.log(`当前页: ${val}`);
            }
        },
    }
</script>

<style scoped lang="scss">
    .setdate {
        .content1 {
            .textnowrap {
                font-size: 13px;
                color: #333;
            }
            .date {
                min-width: 100px;
            }
        }
        .ele-toast{
            .time{
                font-size: 12px;
                padding-left: 2px;
                color: #F56C6C;
                margin-bottom: 10px;
            }
        }
    }

</style>